module.exports = (__webpack_require__(11))(148);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/react-slick/lib/index.js from dll-reference vendor_lib
// module id = 139
// module chunks = 0